import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { first, map, tap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import {
  AppleProfilePresetResolverActions,
  AppleProfilePresetType,
  selectPresetsLoadedByType,
} from '../apple-profile-preset';

export const appleProfilePresetsResolver: (profileType: AppleProfilePresetType) => ResolveFn<boolean> = (
  profileType: AppleProfilePresetType
) => {
  return () => {
    const store = inject(Store);

    return store.select(selectPresetsLoadedByType(profileType)).pipe(
      tap((loaded) => {
        if (!loaded) {
          store.dispatch(AppleProfilePresetResolverActions.presetsRequested({ profileType }));
        }
      }),
      map(() => true),
      first()
    );
  };
};
